import { FC } from 'react';
import { HStack } from '@chakra-ui/react';

import Text from 'components/_core/Text';

interface CompanyDetailsRowProps {
  title: string;
  value?: string;
  hasBorder?: boolean;
}

const CompanyDetailsRow: FC<CompanyDetailsRowProps> = ({
  hasBorder = true,
  title,
  value,
}) => {
  if (!value) {
    return null;
  }

  return (
    <HStack
      borderBottomColor="grey.300"
      borderBottomWidth={hasBorder ? '1px' : '0'}
      justifyContent="space-between"
      padding="space-16"
      w="full"
    >
      <Text variant="secondary">{title}</Text>
      <Text fontWeight="weight-500" textAlign="right" variant="primary">
        {value}
      </Text>
    </HStack>
  );
};

export default CompanyDetailsRow;
